import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import { ToggleService } from '../services/toggle/toggle.service';
import { WindowService } from '../services/window/window.service';
import { Institution } from '../modules/datamodel/institution';
import { User } from '../modules/datamodel/user';
import { AuthService } from '../services/auth/auth.service';
import { StateService } from '../services/state/state.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss'],
    providers: [ToggleService],
    encapsulation: ViewEncapsulation.None
})
export class FullLayoutComponent implements OnInit {
    public user : User;
    public selectedInstitution : Institution;

    public disabled = false;
    public status : {
        isopen: boolean
    } = {
        isopen: false
    };
    _template: string;
    constructor(public afAuth: AngularFireAuth, public auth: AuthService, private state: StateService, private router: Router, public toggle: ToggleService) {
        this._template = "\n <div class=\"lds-ring\"><div></div><div></div><div></div><div></div></div>";   

        auth
            .user
            .subscribe(user => {
                this.user = user
            });

        state
            .selectedInstitution
            .subscribe(si => {
                console.log(si);
                this.selectedInstitution = si
            });
    }

    setInstitution(value) {
        console.log(value);
        this
            .state
            .setSelectedInstitutionPath(value);
    }

    public toggled(open : boolean) : void {
        console.log('Dropdown is now: ', open);
    }

    public toggleDropdown($event : MouseEvent) : void {
        $event.preventDefault();
        $event.stopPropagation();
        this.status.isopen = !this.status.isopen;
    }

    ngOnInit() : void {
        console.log(this.state);
    }

    public logout() {
        console.log('logging out');
        this
            .auth
            .logout();
    }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts